// src/components/Admin/BoardCategoryManager/index.jsx
import { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Button } from '@mui/material';
import CategoryList from './CategoryList';
import CategoryForm from './CategoryForm';
import { getBoardCategories } from '../../../api/admin';
import { useCategory } from '../../../contexts/CategoryContext';

export default function BoardCategoryManager() {
  /* ── Context ────────────────────────── */
  const { reloadCategories } = useCategory();

  /* ── Local state ────────────────────── */
  const [categories, setCategories] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [currentCat, setCurrentCat] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  /* ── API 호출 ───────────────────────── */
  const loadCategories = useCallback(() => {
    getBoardCategories()
      .then((res) => {
        const sorted = [...(res.data.categories ?? [])].sort(
          (a, b) => a.order - b.order,
        );
        setCategories(sorted);
      })
      .catch(console.error);
  }, []);

  useEffect(() => loadCategories(), [loadCategories]);

  /* ── 공통 후처리 ────────────────────── */
  const handleAfterChange = () => {
    loadCategories();
    reloadCategories();
  };

  /* ── UI 이벤트 ──────────────────────── */
  const handleAdd = () => {
    setCurrentCat(null);
    setIsEdit(false);
    setOpenForm(true);
  };
  const handleEdit = (cat) => {
    setCurrentCat(cat);
    setIsEdit(true);
    setOpenForm(true);
  };

  /* ── Render ─────────────────────────── */
  return (
    <Box sx={{ p: 4, '@media (max-width:600px)': { p: 2 } }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{ '@media (max-width:600px)': { fontSize: '1.2rem' } }}
      >
        게시판 카테고리 관리
      </Typography>

      <Button
        variant="contained"
        onClick={handleAdd}
        sx={{
          mb: 2,
          '@media (max-width:600px)': { width: '100%', fontSize: '0.9rem' },
        }}
      >
        ➕ 게시판 추가
      </Button>

      <CategoryList
        categories={categories}
        onEdit={handleEdit}
        reload={handleAfterChange}          /* 테이블 + 사이드바 */
        reloadCategories={reloadCategories} /* 리스트 내부에서 사용 */
      />

      {openForm && (
        <CategoryForm
          open={openForm}
          onClose={() => setOpenForm(false)}
          category={currentCat}
          isEdit={isEdit}
          reload={handleAfterChange}
          reloadCategories={reloadCategories}
        />
      )}
    </Box>
  );
}
